import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios'
import { markSessionExpired } from '../authSession'
import { getStoredToken } from '../tokenStore'

const axiosClient = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
})

// 요청 인터셉터: JWT 토큰 자동 첨부
axiosClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getStoredToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

// 응답 인터셉터: 401 → **페이지를 떠나지 않고** 세션 만료 신호만 올린다(2026-09-22, 사용자 요청).
// ⚠️ 예전에는 여기서 곧바로 `window.location.href = '/login'`로 전체 페이지를 이동시켰다. 문제는 이
// 인터셉터가 명시적인 저장 버튼 클릭뿐 아니라 **배경 오프라인 큐 재전송**(useOfflineSync, 15초 주기)의
// 요청에도 똑같이 걸린다는 것이다 — 기록자가 화면을 보고만 있어도 토큰이 만료되는 순간 페이지가
// 통째로 튕겨나가면서, 이미 "저장"을 눌러 로컬 큐(IndexedDB)에 들어간 투구조차 재로그인 후 그 경기를
// 다시 찾아 들어가기 전까지 전송이 멈췄다. 이제는 `markSessionExpired()`로 신호만 올리고, AuthContext가
// 화면 안에서 재인증 모달(`SessionExpiredModal`)을 띄운다 — 재인증되는 순간 이미 돌고 있던 재전송
// 루프가 그대로 이어진다. 토큰은 여기서 지우지 않는다 — 재인증/조용한 재발급이 새 값으로 덮어쓴다.
axiosClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      markSessionExpired()
    }
    return Promise.reject(error)
  },
)

export default axiosClient
